//NEW STYPEPARAMS METHOD
var ARROWS_VERTICAL_POSITION = {
    ITEM_CENTER: 'ITEM_CENTER',
    IMAGE_CENTER: 'IMAGE_CENTER',
    INFO_CENTER: 'INFO_CENTER',
};
export default ARROWS_VERTICAL_POSITION;
//# sourceMappingURL=layoutParams_navigationArrows_verticalAlignment.js.map